// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"d716c36b","164":"ac0a57b7","313":"cac86330","379":"ef24a58e","880":"d310535e"}[chunkId] + ".chunk.js";
};